<template>
  <div>

    <div class="time-text time-pt" v-if="msg.type==='timeTag'">{{msg.showText}}</div>
    <div class="time-text time-pt" v-if="msg.type==='tip'">
      <span>{{msg.showText}}</span>
      <a v-if="msg.custom.revocateMsg" @click="reEdit(msg.custom.revocateMsg)">重新编辑</a>
    </div>

    <template v-if="msg.type==='custom' && msg.content.type==='303001'">
      <div class="chat-list-item item-tip" v-if="userType=='01'">
        <span v-html="msg.content.body.content"></span>
      </div>
    </template>
    <template v-else>
      <div class="chat-container" :class="[msg.flow==='out'?'patient':'doctor']" v-if="msg.type!='timeTag' && msg.type!='tip'">
          <img class="img-avater border-white" :src="msg.avatar">
          <!-- <template v-if="userType=='01'">
            <img class="img-avater border-white" src="../../assets/images/avatar_male.png" v-if="msg.flow==='out'">
            <img class="img-avater border-white" src="../../assets/images/default_male.png" v-else>
          </template>
          <template v-if="userType=='03'">
            <img class="img-avater border-white" src="../../assets/images/default_male.png" v-if="msg.flow==='out'">
            <img class="img-avater border-white" src="../../assets/images/avatar_male.png" v-else>
          </template> -->
          <template v-if="msg.type==='custom'">
            <div class="chat-content type-info" v-if="msg.content.type==='301001'">
                <div class="chat-title black">{{msg.content.body.patientName}}  {{msg.content.body.sex}}  {{msg.content.body.age}}岁</div>
                <div class="chat-detail is-block">
                    {{msg.content.body.symptomDesc}}
                    <div class="img-container" v-if="msg.content.body.imgurl">
                        <img :src="url" alt="" v-for="(url,i) in msg.content.body.imgurl" @click="showFullImg(url)">
                    </div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301002'">
                <div class="chat-title">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301003'">
                <div class="chat-title">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301004'" @click="goLink(msg)">
                <div class="chat-title black arrow">{{msg.content.body.title}}</div>
                <div class="chat-detail is-block">
                    <div class="info-title">{{msg.content.body.patientName}}  {{msg.content.body.sex}}  {{msg.content.body.age}}岁</div>
                    <div class="info-content">原因：{{msg.content.body.reason}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301005'">
                <div class="chat-title">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301006'">
                <div class="chat-title">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301007'">
                <div class="chat-title">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301008'">
                <div class="chat-title black arrow">{{msg.content.body.title}}</div>
                <div class="chat-detail is-block">
                    <div class="info-title">{{msg.content.body.patientName}}  {{msg.content.body.sex}}  {{msg.content.body.age}}岁</div>
                    <div class="info-content">原因：{{msg.content.body.reason}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301009'" @click="goConsultLink(msg)">
                <div class="chat-title">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                  <div class="info-content" v-html="msg.content.body.content"></div>
              </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='301010'">
                <div class="chat-title">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302001'">
                <div class="chat-title dark">{{msg.content.body.doctorName}}{{msg.content.body.title}}</div>
                <div class="chat-detail is-block">
                    <div class="info-title">{{msg.content.body.dept}}  {{msg.content.body.doctorTitle}}</div>
                    <div class="info-content">擅长：{{msg.content.body.speciality}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302002'">
                <div class="chat-title dark">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content" v-if="msg.content.body.reason">{{msg.content.body.reason}}</div>
                    <div class="info-content" v-else>{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302003'">
                <div class="chat-title dark">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
                <template v-if="endAskTime == msg.time">
                  <div class="choose-container" v-if="userType=='01' && recordStatus == '03' && orderNo == msg.content.orderNo && autoTime != '0'">
                      <div class="continue-btn" @click="continueChat">继续咨询</div>
                      <div class="end-btn" @click="endChat">结束咨询</div>
                  </div>
                  <div class="chat-foot" v-if="userType=='03' && recordStatus == '03' && orderNo == msg.content.orderNo && autoTime != '0'">
                    <span>等待患者确认</span>
                  </div>
                  <div class="chat-foot" v-if="recordStatus == '03' && orderNo == msg.content.orderNo && autoTime == '0'">
                    <span>确认继续咨询</span>
                  </div>
                </template>
                <template v-else>
                  <div class="chat-foot" v-if="recordStatus == '03' && orderNo == msg.content.orderNo">
                    <span>确认继续咨询</span>
                  </div>
                </template>
                <div class="chat-foot" v-if="userType=='01' && (recordStatus != '03' || orderNo != msg.content.orderNo)">
                  <span>您已同意结束</span>
                </div>
                <div class="chat-foot" v-if="userType=='03' && (recordStatus != '03' || orderNo != msg.content.orderNo)">
                  <span>患者已同意结束</span>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302004'" @click="goLink(msg)">
                  <div class="chat-title dark">{{msg.content.body.examine}}</div>
                  <div class="chat-detail is-block">
                      <!-- <div class="info-title">处方 {{msg.content.body.prescriptionId}}</div> -->
                      <div class="info-title">{{msg.content.body.patientName}}  {{msg.content.body.sex}}  {{msg.content.body.age}}岁</div>
                      <div class="info-content">{{msg.content.body.content}}</div>
                  </div>
              </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302005'" @click="goLink(msg)">
                <div class="chat-title black arrow">
                  <span>{{msg.content.body.title}}</span>
                  <i class="tb" v-if="msg.content.body.isSpecialDiseases == '1'">特病</i>
                </div>
                <div class="chat-detail is-block">
                <div class="info-title">{{msg.content.body.patientName}}  {{msg.content.body.sex}}  {{msg.content.body.age}}岁</div>
                <!-- <div class="info-content">诊断内容：{{msg.content.body.reason}}</div> -->
                <div class="info-content">药品信息：{{msg.content.body.content}}</div>
            </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302006'">
                <div class="chat-title dark">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302008'">
                <div class="chat-title dark">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                    <div class="info-content">{{msg.content.body.text}}</div>
                </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302011'">
              <div class="chat-title dark">{{msg.content.body.title}}</div>
              <div class="chat-detail">
                  <div class="info-content">{{msg.content.body.text}}</div>
              </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302012'" @click="goConsultLink(msg)">
                <div class="chat-title dark arrow">{{msg.content.body.title}}</div>
                <div class="chat-detail">
                  <div class="info-content" v-html="msg.content.body.content"></div>
              </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302013'">
              <div class="chat-title dark">{{msg.content.body.title}}</div>
              <div class="chat-detail">
                  <div class="info-content">{{msg.content.body.text}}</div>
              </div>
            </div>
            <div class="chat-content type-info" v-if="msg.content.type==='302014'">
                <div class="chat-title dark">{{msg.content.body.title}}</div>
                <div class="chat-detail is-block">
                    <div class="info-title">{{msg.content.body.patientName}}  {{msg.content.body.sex}}  {{msg.content.body.age}}岁</div>
                    <div class="info-content">{{msg.content.body.content}}</div>
                </div>
            </div>
          </template>
          <div class="chat-content unselect type-dialog" v-else :class="[msg.flow==='out'?'':'dark',msg.type==='image'?'img-dialog':'']">
              <div class="chat-detail emoji is-block" v-if="msg.type==='text'" @touchstart="revocateMsg(msg,$event)" @touchend="clearLoop(msg,$event)" v-html="msg.showText"></div>
              <div class="chat-detail max-100" v-if="msg.type==='image'" @touchstart="revocateMsg(msg,$event)" @touchend="clearLoop(msg,$event)" ref="mediaMsg">
              </div>
              <div class="chat-detail" v-if="msg.type==='notification'" v-html="msg.showText"></div>
              <div class="chat-detail" v-if="msg.type==='custom-type1'" @touchstart="revocateMsg(msg,$event)" @touchend="clearLoop(msg,$event)" ref="mediaMsg">
              </div>
              <div class="chat-detail" v-if="msg.type==='custom-type3'" @touchstart="revocateMsg(msg,$event)" @touchend="clearLoop(msg,$event)" ref="mediaMsg">
              </div>
              <div v-if="msg.type==='audio'" class="chat-detail msg-audio" @touchstart="revocateMsg(msg,$event)" @touchend="clearLoop(msg,$event)" :class="{'unreadAudio': msg.unreadAudio}" :style="'width: ' + msg.width">
                <i>{{msg.showText}}"</i>
                <span class="icon-voice"></span>
              </div>
              <div v-if="msg.type==='video'" class="chat-detail msg-video" @touchstart="revocateMsg(msg,$event)" @touchend="clearLoop(msg,$event)">
                <i>视频播放</i>
                <span class="icon-video"></span>
              </div>
          </div>
          <!-- <div class="chat-content type-info">
              <div class="chat-title black arrow">续方申请</div>
              <div class="chat-detail">
                  <div class="info-title">李晓明  男  26岁</div>
                  <div class="info-content">原因：上次开的药已经吃完了，感觉还需要再开些药。</div>
              </div>
          </div> -->
      </div>
    </template>

    <!-- <div class="chat-container patient">
        <img class="img-avater border-white" src="../assets/images/user_female.png" alt="">
        <div class="chat-content type-dialog dark">
            <div class="chat-detail">你好，这次续方的药品更换了厂家，药效和以前是一样的，不用担心。</div>
        </div>
    </div>
    <div class="chat-container doctor">
        <img class="img-avater border-white" src="../assets/images/user_male.png" alt="">
        <div class="chat-content type-dialog">
            <div class="chat-detail">好的，谢谢医生</div>
        </div>
    </div>
    <div class="chat-container patient">
        <img class="img-avater border-white" src="../assets/images/user_female.png" alt="">
        <div class="chat-content type-info">
            <div class="chat-title dark">通过审核</div>
            <div class="chat-detail">
                <div class="info-title">处方 20190511175438</div>
                <div class="info-content">格列齐特缓释片：60mg×15片/盒；格列齐特缓释片：60mg×15片/盒</div>
            </div>
        </div>
    </div> -->

    <!-- 接收消息 -->
    <!-- <div class="chat-inform clearfix" v-if="msg.flow==='in'">
        <img class="portraitimg other-img fn-fl" :src="msg.avatar" alt="">
        <div class="exchange disease fn-fl" :class="{'voice-type':msg.type==='audio'}">
            <p class="disdes" v-if="msg.type==='text'" v-html="msg.showText"></p>
            <div v-if="msg.type==='image'" ref="mediaMsg" @click="showFullImg(msg.originLink)">
            </div>
            <p class="disdes" v-if="msg.type==='notification'" v-html="transNotification(msg)"></p>
            <div v-if="msg.type==='custom-type1'" ref="mediaMsg"></div>
            <div v-if="msg.type==='custom-type3'" ref="mediaMsg"></div>
            <div v-if="msg.type==='audio'" class="msg-text msg-audio" :class="{'unreadAudio': msg.unreadAudio}" :style="'width: ' + msg.width" @click="playAudio(msg, $event)" v-html="msg.showText"></div>
        </div>
    </div> -->
    <!-- 发送消息 -->
    <!-- <div class="chat-inform clearfix" v-if="msg.flow==='out'">
        <img class="portraitimg own-img fn-fr" :src="msg.avatar" alt="">
        <div class=" exchange treatment fn-fr" :class="{'voice-type':msg.type==='audio'}">
            <p class="disdes" v-if="msg.type==='text'" v-html="msg.showText"></p>
            <div v-if="msg.type==='image'" ref="mediaMsg" @click="showFullImg(msg.originLink)">
            </div>
            <p class="disdes" v-if="msg.type==='notification'" v-html="transNotification(msg)"></p>
            <div v-if="msg.type==='custom-type1'" ref="mediaMsg"></div>
            <div v-if="msg.type==='custom-type3'" ref="mediaMsg"></div>
            <div v-if="msg.type==='audio'" class="msg-text msg-audio" :class="{'unreadAudio': msg.unreadAudio}" :style="'width: ' + msg.width" @click="playAudio(msg, $event)" v-html="msg.showText"></div>
        </div>
    </div> -->
  </div>
</template>

<script type="text/javascript">
  import util from '@/utils'
  import config from '@/config'
  import { mapGetters } from "vuex";
  import emojiObj from '@/config/emoji'
  import api from "@/config/api";
  import cookie from 'js-cookie';
  var audio = { // 正在播放音频的 audio、target
    $node: null,
    $audio: null,
    timeout: '',
    imgPlay0: 'https://yx-web-nosdn.netease.im/quickhtml%2Fassets%2Fyunxin%2Fdefault%2Fplay0.gif',
    imgPlay1: 'https://yx-web-nosdn.netease.im/quickhtml%2Fassets%2Fyunxin%2Fdefault%2Fplay1.gif'
  }
  export default {
    props: {
      type: String, // 类型，chatroom, session
      rawMsg: {
        type: Object,
        default () {
          return {}
        }
      },
      userInfos: {
        type: Object,
        default () {
          return {}
        }
      },
      myInfo: {
        type: Object,
        default () {
          return {}
        }
      },
      doctorAvatar:{
        type: String,
        default() {
          return ""
        }
      },
      doctorSex:{
        type: String,
        default() {
          return ""
        }
      },
      userSex:{
        type: String,
        default() {
          return ""
        }
      },
      isRobot: {
        type: Boolean,
        default () {
          return false
        }
      },
      isHistory: {
        type: Boolean,
        default() {
          return false
        }
      },
      userType: {
        type: String,
        default() {
          return ""
        }
      },
      orderNo:{
        type: String,
        default() {
          return ""
        }
      },
      endAskTime:{
        default() {
          return ""
        }
      },
      autoTime: {
        default() {
          return 0
        }
      }
      // robotInfos: {
      //   type: Object,
      //   default () {
      //     return {}
      //   }
      // }
    },
    data () {
      return {
        touchTimer:"",
        touchTime:0,
        msg: '',
        isFullImgShow: false,
        docDefaultImg:{
          "1":require("../../assets/images/doctor/icon-doc-male.png"),
          "2":require("../../assets/images/doctor/icon-doc-female.png")
        },
        patDefaultImg:{
          "1":require("../../assets/images/doctor/icon-male.png"),
          "2":require("../../assets/images/doctor/icon-female.png")
        }
      }
    },
    computed: {
      ...mapGetters([
        "userInfo"
      ]),
      robotInfos () {
        return this.$store.state.nimSDK.robotInfos
      },
      recordStatus() {
        return this.$store.state.nimSDK.recordStatus
      },
      teamMsgUnRead() {
        var obj = !this.isHistory
        && this.msg.needMsgReceipt
        && this.msg.flow==='out'
        && this.$store.state.nimSDK.teamMsgReads.find(item => item.idServer === this.msg.idServer)

        return obj ? parseInt(obj.unread) : -1
      }
    },
    watch: {
      rawMsg (newVal, oldVal) {
        let newCustom = newVal && newVal.localCustom
        if (!newCustom || !newVal || newVal.type !== 'audio') {
          return
        }
        let oldCustom = oldVal && oldVal.localCustom
        if (newCustom !== oldCustom) {
          this.computedItem()
        }
      }
    },
    beforeMount () {
      this.computedItem()
    },
    mounted () {
      let item = this.msg

      window.stopPlayAudio = this.stopPlayAudio.bind(this)
      // 有时序问题的操作
      this.$nextTick(() => {
        let media = null
        if (item.type === 'image') {
          // 图片消息缩略图
          media = new Image()
          media.src = item.file.url + '?imageView&thumbnail=180x0&quality=85'
        } else if (item.type === 'custom-type1') {
          // 猜拳消息
          media = new Image()
          media.className = 'emoji-middle'
          media.src = item.imgUrl
        } else if (item.type === 'custom-type3') {
          // 贴图表情
          media = new Image()
          media.className = 'emoji-big'
          media.src = item.imgUrl
        } else if (item.type === 'video') {
          if (/(mov|mp4|ogg|webm)/i.test(item.file.ext)) {
            this.$emit('msg-loaded')
            // media = document.createElement('video')
            // media.src = item.file.url
            // media.autoStart = false
            // media.controls = 'controls'  /*这个属性规定浏览器为该视频提供播放控件*/
            // media.preload="auto" /*这个属性规定页面加载完成后载入视频*/
            // media.setAttribute('splaysinline',true)  /*IOS微信浏览器支持小窗内播放*/
            // media.style="object-fit:fill"  /*加这个style会让 Android / web 的视频在微信里的视频全屏，如果是在手机上预览，会让视频的封面同视频一样大小*/
            // media.setAttribute('webkit-playsinline',true)  /*这个属性是ios 10中设置可以让视频在小窗内播放，也就是不是全屏播放*/
            // media.setAttribute('x-webkit-airplay',"allow")  /*这个属性还不知道作用*/
            // media.setAttribute('x5-video-player-type',"h5") /*启用H5播放器,是wechat安卓版特性*/
            // media.setAttribute('x5-video-orientation',"h5") /*播放器支付的方向，landscape横屏，portraint竖屏，默认值为竖屏*/
            // media.setAttribute('x5-video-player-fullscreen',true) /*全屏设置，设置为 true 是防止横屏*/
            // media.width = 640
            // media.height = 480
          } else {
            let aLink = document.createElement('a')
            aLink.href = item.file.url
            aLink.target = '_blank'
            aLink.innerHTML = `<i class="u-icon icon-file"></i>${video.name}`
            this.$refs.mediaMsg.appendChild(aLink)
          }
        }
        if (media) {
          if (this.$refs.mediaMsg) {
            this.$refs.mediaMsg.appendChild(media)
          }
          media.onload = () => {
            this.$emit('msg-loaded')
          }
          media.onerror = () => {
            this.$emit('msg-loaded')
          }
        } else {
          this.$emit('msg-loaded')
        }
      }) // end this.nextTick
    },
    methods: {
      computedItem () {
        let item = Object.assign({}, this.rawMsg)
        // 标记用户，区分聊天室、普通消息
        if (this.type === 'session') {
          if (item.flow === 'in') {
            var defaultUserIcon = this.userType=='01'?this.docDefaultImg[this.doctorSex]:this.patDefaultImg[this.userSex];
            if (item.type === 'robot' && item.content && item.content.msgOut) {
              // 机器人下行消息
              let robotAccid = item.content.robotAccid
              item.avatar = this.robotInfos[robotAccid].avatar
              item.isRobot = true
              item.link = `#/namecard/${robotAccid}`
            } else if (item.from !== this.$store.state.nimSDK.userUID) {
              var avatar = this.userType=='01'?this.doctorAvatar:(this.userInfos[item.from]?this.userInfos[item.from].avatar:"");
              item.avatar = (avatar.indexOf("default-icon.png")<0 && avatar) || defaultUserIcon
              item.link = `#/namecard/${item.from}`
              //todo  如果是未加好友的人发了消息，是否能看到名片
            } else {
              var avatar = this.userType=='01'?this.doctorAvatar:this.myInfo.avatar;
              item.avatar = (avatar.indexOf("default-icon.png")<0 && avatar) || defaultUserIcon
            }
          } else if (item.flow === 'out') {
            var defaultUserIcon = this.userType=='01'?this.patDefaultImg[this.userSex]:this.docDefaultImg[this.doctorSex];
            var avatar = this.userType=='01'?this.myInfo.avatar:this.doctorAvatar;

            item.avatar = (avatar.indexOf("default-icon.png")<0 && avatar) || defaultUserIcon
          }
        } else {
          // 标记时间，聊天室中
          item.showTime = util.formatDate(item.time)
        }
        if (item.type === 'timeTag') {
          // 标记发送的时间
          item.showText = item.text
        } else if (item.type === 'text') {
          // 文本消息
          item.showText = util.escape(item.text)
          if (/\[[^\]]+\]/.test(item.showText)) {
            let emojiItems = item.showText.match(/\[[^\]]+\]/g)
            emojiItems.forEach(text => {
              let emojiCnt = emojiObj.emojiList.emoji
              if (emojiCnt[text]) {
                item.showText = item.showText.replace(text, `<img class="emoji-small" src="${emojiCnt[text].img}">`)
              }
            })
          }
        } else if (item.type === 'custom') {
          let content = JSON.parse(item.content)
          item.content = content;
          // type 1 为猜拳消息
          if (content.type === 1) {
            let data = content.data
            let resourceUrl = config.resourceUrl
            // item.showText = `<img class="emoji-middle" src="${resourceUrl}/im/play-${data.value}.png">`
            item.type = 'custom-type1'
            item.imgUrl = `${resourceUrl}/im/play-${data.value}.png`
          // type 3 为贴图表情
          } else if (content.type === 3) {
            let data = content.data
            let emojiCnt = ''
            if (emojiObj.pinupList[data.catalog]) {
              emojiCnt = emojiObj.pinupList[data.catalog][data.chartlet]
              // item.showText = `<img class="emoji-big" src="${emojiCnt.img}">`
              item.type = 'custom-type3'
              item.imgUrl = `${emojiCnt.img}`
            }
          } else {
            this.$emit('custom-fun',item)
            // item.showText = util.parseCustomMsg(item)
            // if (item.showText !== '[自定义消息]') {
            //   item.showText += ',请到手机或电脑客户端查看'
            // }
          }
        } else if (item.type === 'image') {
          // 原始图片全屏显示
          item.originLink = item.file.url
        } else if (item.type === 'video') {
          // ...
        } else if (item.type === 'audio') {
          let dpi = parseFloat(document.documentElement.style.fontSize);
          item.width = ((140/75*dpi) + Math.round(item.file.dur / 1000) * (20/75*dpi)).toFixed(2) + 'px'
          item.audioSrc = item.file.mp3Url
          item.showText = Math.round(item.file.dur / 1000)
          if (!this.isHistory && this.$store.state.nimSDK.nim.useDb) {
            item.unreadAudio = !item.localCustom
          }
        } else if (item.type === 'file') {
          item.fileLink = item.file.url
          item.showText = item.file.name
        } else if (item.type === 'notification') {
          if (item.scene === 'team') {
            item.showText = util.generateTeamSysmMsg(item)
          } else {
            //对于系统通知，更新下用户信息的状态
            item.showText = this.transNotification(item)
          }
        } else if (item.type === 'tip') {
          //对于系统通知，更新下用户信息的状态
          item.showText = item.tip
          item.custom = JSON.parse(item.custom)
        } else if (item.type === 'robot') {
          let content = item.content || {}
          let message = content.message || []
          if (!content.msgOut) {
            // 机器人上行消息
            item.robotFlow = 'out'
            item.showText = item.text
          } else if (content.flag === 'bot') {
            item.subType = 'bot'
            message = message.map(item => {
              if (item.type === 'template') {
                // 在vuex(store/actions/msgs.js)中已调用sdk方法做了转换
                return item.content.json
              } else if (item.type === 'text' || item.type === 'answer') {
                // 保持跟template结构一致
                return [{
                  type: 'text',
                  text: item.content
                }]
              } else if (item.type === 'image') {
                // 保持跟template结构一致
                return [{
                  type: 'image',
                  url: item.content
                }]
              }
            })
            item.message = message
          } else if (item.content.flag === 'faq') {
            item.subType = 'faq'
            item.query = message.query
            let match = message.match.sort((a, b) => {
              // 返回最匹配的答案
              return b.score - a.score
            })
            item.message = match[0]
          }
        } else {
          item.showText = `[${util.mapMsgType(item)}],请到手机或电脑客户端查看`
        }
        this.msg = item
      },
      reEdit(text){
        this.$emit('re-edit',text)
      },
      revocateMsg (msg,e) {
        e.preventDefault();
        var date = new Date().getTime();
        var longTime = (date - msg.time)/60000;
        clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(res => {
          // 在会话聊天页
          if (this.$store.state.nimSDK.currSessionId) {
            if (msg.type === 'robot') {
              return
            }
            // 自己发的消息
            if (msg.flow === 'out' && longTime<2) {
              this.$emit('revocate-msg',msg)
            }
          }
        },1000)
        this.touchTime = 0;
        this.touchTimer = setInterval(res => {
          this.touchTime++;
        },1000)
      },
      clearLoop(msg,e) {
        clearTimeout(this.Loop);
        clearInterval(this.touchTimer);
        if(this.touchTime<1){
          console.log(msg.type)
          if(msg.type=="image"){
            this.showFullImg(msg.originLink)
          }
          if(msg.type=="audio"){
            this.playAudio(msg, e)
          }
          if(msg.type=="video"){
            this.goPlayVideo(msg)
          }
        }
      },
      sendRobotBlockMsg (msg, originMsg) {
        if(this.isHistory) {
          // 在历史消息中，不进行机器人交互
          return
        }
        let body = '[复杂按钮模板触发消息]'
        if (msg.text && msg.text.length === 1) {
          body = msg.text[0].text
        }
        let robotAccid = originMsg.content.robotAccid
        if (!this.isRobot) {
          body = `@${this.robotInfos[robotAccid].nick} ${body}`
        }
        if (this.type === 'session') {
          this.$store.dispatch('sendRobotMsg', {
            type: 'link',
            scene: originMsg.scene,
            to: originMsg.to,
            robotAccid,
            // 机器人后台消息
            params: msg.params,
            target: msg.target,
            // 显示的文本消息
            body
          })
        } else if (this.type === 'chatroom') {
          this.$store.dispatch('sendChatroomRobotMsg', {
            type: 'link',
            robotAccid,
            // 机器人后台消息
            params: msg.params,
            target: msg.target,
            // 显示的文本消息
            body
          })
        }
      },
      continueRobotMsg (robotAccid) {
        this.$store.dispatch('continueRobotMsg', robotAccid)
      },
      showFullImg (src) {
        // this.$store.dispatch('showFullscreenImg', {
        //   src
        // })
        this.$emit('show-img',src)
      },
      autoPlayNextUnreadAudio () {
        var parentNode = audio.$node && audio.$node.parentElement
        if (!parentNode) {
          return
        }
        var currentMsgNode = parentNode.parentElement
        var nextMsgNode = currentMsgNode.nextElementSibling
        var nextAudioNode
        while (nextMsgNode) {
          if (~nextMsgNode.className.indexOf('item-you')) {
            nextAudioNode = nextMsgNode.querySelector('.msg-audio')
            if (nextAudioNode) {
              break
            }
          }
          nextMsgNode = nextMsgNode.nextElementSibling
        }
        if (nextMsgNode && ~nextAudioNode.className.indexOf('unreadAudio')) {
          nextAudioNode.click()
        }
      },
      playAudio (msg, event) {
        var $target
        if (!~event.target.className.indexOf('msg-audio')) {
          $target = event.target.parentElement
        } else {
          $target = event.target
        }
        if (audio.$audio) {
          var targetChild1 = $target.childNodes[2]
          var sameNode = targetChild1 && targetChild1.tagName === "IMG"
          this.stopPlayAudio()
          if (sameNode) {
            return
          }
        }
        var duration = msg.file.dur
        if (!duration) {
          return
        }
        audio.$audio = document.createElement('audio')
        var $source = document.createElement('source')
        var audioType = msg.file.ext
        $source.src = msg.file.url
        $source.type = 'audio/' + (audioType === 'mp3' ? 'mpeg' : audioType)
        audio.$audio.appendChild($source)
        audio.$audio.play()
        audio.$node = $target
        // $target.innerHTML = $target.innerHTML.replace('点击播放','<img src="' + (msg.flow === 'in' ? audio.imgPlay1 : audio.imgPlay0) + '">')
        this.addClass($target,"voice-play")
        audio.timeout = setTimeout(() => {
          audio.$audio = null
          this.canclePlayAudio()
        }, duration)
        if (~audio.$node.className.indexOf('unreadAudio')) {
          msg.localCustom = '{"audio": "played"}'
          this.$store.dispatch('updateLocalMsg', msg)
          audio.$node.className = audio.$node.className.replace('unreadAudio', '')
          audio.$audio.onended = this.autoPlayNextUnreadAudio.bind(this)
        }
      },
      canclePlayAudio () {
        this.removeClass(audio.$node,"voice-play")
      },
      stopPlayAudio () {
        if (audio.$audio) {
          audio.$audio.pause()
          this.canclePlayAudio()
          clearTimeout(audio.timeout)
          audio.$audio = null
          audio.$node = null
          audio.timeout = ''
        }
      },
      hasClass(ele, cls) {
        return ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
      },
      //为指定的dom元素添加样式
      addClass(ele, cls) {
        if (!this.hasClass(ele, cls)) ele.className += " " + cls;
      },
      //删除指定dom元素的样式
      removeClass(ele, cls) {
        if (this.hasClass(ele, cls)) {
          var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
          ele.className = ele.className.replace(reg, " ");
        }
      },
      toMsgUnReadDetail() {
        this.href = '#/msgReceiptDetail/' + this.msg.idServer
      },
      getNetcallDurationText(allSeconds) {
          var result = "";
          var hours, minutes, seconds;
          if (allSeconds >= 3600) {
              hours = parseInt(allSeconds / 3600);
              result += ("00" + hours).slice(-2) + " : ";
          }
          if (allSeconds >= 60) {
              minutes = parseInt(allSeconds % 3600 / 60);
              result += ("00" + minutes).slice(-2) + " : ";
          } else {
              result += "00 : ";
          }
          seconds = parseInt(allSeconds % 3600 % 60);
          result += ("00" + seconds).slice(-2);
          return result;
      },
      transNotification(item) {
          var type = item.attach.type;
          var netcallType = item.attach.netcallType;
          switch (type) {
              case 'netcallMiss':
                  return '未接听';
                  break;
              case 'netcallBill':
                  return "通话" + (item.flow === "in" ? "接听" : "拨打") + "时长 " + this.getNetcallDurationText(item.attach.duration);
                  break;
              case 'cancelNetcallBeforeAccept':
                  return '无人接听';
                  break;
              case 'rejectNetcall':
                  return '已拒绝';
                  break;
              case 'netcallRejected':
                  return '对方已拒绝';
                  break;
              default:
                  return '';
                  break;
          }
      },
      /**
       * 全屏播放视频
       */
      goPlayVideo(item) {
        cookie.set('videoUrl', item.file.url)
        this.$router.push({path: "/videoPlay", query: {}});
      },
      goConsultLink(item){
        var custom = JSON.parse(item.custom);
        var url = item.content.body.url.replace(/\?/g,"&");
        var type = item.content.type;
        if(type == "302012"){
          this.$router.push({path: "/questionnaire?", query: {orderNo:custom.orderNo,userType:this.userType}});
          console.log("问卷调查跳转")
        }
        if(type == "301009" && this.userType == "03"){
          // this.$router.push({path: "/questionnaire?", query: {orderNo:custom.orderNo}});
          console.log("问卷调查结果")
        }
      },
      goLink(item){
        var custom = JSON.parse(item.custom);
        var url = item.content.body.url.replace(/\?/g,"&");
        var urls = url.split("|");
        if(urls.length == 0){
          console.error("卡片未推送跳转链接")
          return false;
        }
        if(urls.length == 1){
          window.location.href = api.recipeBase + url + "&sessionId=" + this.$store.state.user.token + "&orderNo=" + custom.orderNo;
        }else{
          if(this.userType == "03"){
            window.location.href = api.recipeBase + urls[1] + "&sessionId=" + this.$store.state.user.token + "&realNameStatus=" + this.userInfo.realNameStatus + "&orderNo=" + custom.orderNo;
          }else{
            window.location.href = api.recipeBase + urls[0] + "&sessionId=" + this.$store.state.user.token + "&orderNo=" + custom.orderNo;
          }
        }
      },
      goAbsoluteLink(url){
        window.location.href = url;
      },
      endChat(){
        this.$emit('end-chat')
      },
      continueChat(){
        this.$emit('continue-chat')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/chatItem.vue